import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import colors from "backpack-ui/dist/styles/colors";

const styles = {
  wrapper: {
    textAlign: "center",
    background: colors.bgSecondary,
    padding: "32px 16px",
  },
  title: {
    marginBottom: "8px",
    color: colors.textPrimary,
    fontSize: "24px",
    fontWeight: "bold",
  },
};
const BookingWrapper = ({ children, title }) => (
  <div style={styles.wrapper}>
    <h4 style={styles.title}>{title}</h4>
    {children}
  </div>
);

BookingWrapper.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
};

BookingWrapper.defaultProps = {
  title: "Check Availability",
};

export default radium(BookingWrapper);


// WEBPACK FOOTER //
// ./assets/pois/components/booking/bookingWrapper.jsx